import styled from "styled-components";
import { ParagraphSmall } from "baseui/typography";

// The $ before 'danger' is necessary due to booleans not being acceptable when rendered to the DOM
// See https://styled-components.com/docs/api#transient-props
export const StyledCharacterCounter = styled(ParagraphSmall)<{ $danger: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: ${({ theme }) => theme.sizing.scale300};
  margin-bottom: ${({ theme }) => theme.sizing.scale300};
  color: ${({ theme, $danger }) =>
    $danger ? theme.colors.negative : theme.colors.contentTertiary};
  max-width: 620px;
`;
